import { render, staticRenderFns } from "./BotSettings.vue?vue&type=template&id=ab824b88&"
import script from "./BotSettings.vue?vue&type=script&lang=js&"
export * from "./BotSettings.vue?vue&type=script&lang=js&"
import style0 from "./BotSettings.vue?vue&type=style&index=0&id=ab824b88&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports